// TicketPeek — the peek face of the ONE ticket panel (`?peek=tickets:<id>`,
// rendered by the global PeekHost): TicketPanel as the standard one-level
// peek, hosting the review walk itself — the last answer closes the walk, says
// so, and moves the peek on to the next row of the list's walk that drives it
// (stores/rowWalkStore — none from a page without one: the ticket stays).

import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useToast } from '../../components/ui/Toast.js';
import { useTicketDetail } from '../../hooks/useTickets.js';
import { stepPeekWalk } from '../../stores/rowWalkStore.js';
import { TicketPanel } from './TicketPanel.js';
import { TicketFileSurface } from './TicketFileSurface.js';

export interface TicketPeekProps {
  projectId: string;
  ticketId: string;
  onClose: () => void;
}

export function TicketPeek({ projectId, ticketId, onClose }: TicketPeekProps) {
  const { t } = useTranslation('tickets');
  const toast = useToast();
  const [walk, setWalk] = useState(false);
  // The same read the panel makes — one cache entry, no second request.
  const detail = useTicketDetail(projectId, ticketId);

  return (
    <>
      <TicketPanel projectId={projectId} ticketId={ticketId} onClose={onClose} onReview={() => setWalk(true)} />
      {walk && detail.data && (
        <TicketFileSurface
          mode="review"
          projectId={projectId}
          ticket={detail.data}
          canReview
          onClose={() => setWalk(false)}
          onDone={() => {
            setWalk(false);
            toast.success(t('toast.reviewedAll'));
            stepPeekWalk();
          }}
        />
      )}
    </>
  );
}
